export default __webpack_public_path__ + "static/1.2_FR-7ada3ecdf93fafc26e488414d8118337.webp";